import React from 'react';
import { TableRow, makeStyles } from '@material-ui/core';
import TableComponents from 'components/Table';
import { formatCurrency, formatPercent } from 'utils';

const useStyles = makeStyles((theme: any) => {
  return {
    box: {
      height: '100%',
      boxShadow: 'none'
    },
    footer: {
      lineHeight: '1rem',
      padding: '0.5rem 1rem',
      fontSize: '0.8rem',
      height: '4.125rem',
      border: 0,
      borderTop: '1px solid #eaeaea',
      '& td': {
        height: '4.125rem',
        color: theme.palette.baseColors.primary,
        textTransform: 'uppercase',
        fontWeight: 600
      }
    },
    chargeRow: {
      '&:nth-child(even)': {
        backgroundColor: '#f9f9f9'
      },
      '&:nth-child(odd)': {
        backgroundColor: 'initial !important'
      }
    }
  };
});
interface ChargesTableRowProps {
  charges: any;
  type: string;
}

const ChargesTableRow = ({ charges, type }: ChargesTableRowProps) => {
  const classes = useStyles();

  const formattedData = (charge: any, chargeKeys: any) => {
    chargeKeys = [chargeKeys].flat();
    let cashValue = 0;
    let percentageValue = 0;

    chargeKeys.forEach((chargeKey: string) => {
      if (
        charge.charges[chargeKey] &&
        charge.charges[chargeKey]['cash_value']
      ) {
        cashValue += charge.charges[chargeKey]['cash_value'];
        percentageValue += charge.charges[chargeKey]['percentage_value'];
      }

      if (chargeKey == 'total_excluding_adviser_cash_value') {
        cashValue += charge['total_excluding_adviser_cash_value'];
        percentageValue += charge['total_excluding_adviser_percentage_value'];
      }

      if (chargeKey == 'cash_value') {
        cashValue += charge['cash_value'];
        percentageValue += charge['percentage_value'];
      }
    });

    return (
      <div>
        <div>{formatPercent(percentageValue * 100)}</div>
        <div>{formatCurrency(cashValue)}</div>
      </div>
    );
  };

  return charges.map((charge: any, index: number) => {
    return (
      <TableRow
        key={index}
        className={`${charge.type === 'Overall' ? classes.footer : ''} ${classes.chargeRow}`}
      >
        <TableComponents.TableCell width="30%">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {charge.type === 'Overall' ? (
              <>{type} Overall</>
            ) : (
              <>{charge.name}</>
            )}
          </div>
        </TableComponents.TableCell>
        <TableComponents.TableCell>
          {formattedData(charge, 'ongoing_charge_figure')}
        </TableComponents.TableCell>
        <TableComponents.TableCell>
          {formattedData(charge, 'fund_trading_cost')}
        </TableComponents.TableCell>
        <TableComponents.TableCell>
          {formattedData(charge, ['platform_charge', 'policy_charge'])}
        </TableComponents.TableCell>
        <TableComponents.TableCell>
          {formattedData(charge, 'portfolio_management_charge')}
        </TableComponents.TableCell>
        <TableComponents.TableCell>
          {formattedData(charge, 'other')}
        </TableComponents.TableCell>
        <TableComponents.TableCell>
          {formattedData(charge, 'total_excluding_adviser_cash_value')}
        </TableComponents.TableCell>
        <TableComponents.TableCell>
          {formattedData(charge, 'ongoing_adviser_charge')}
        </TableComponents.TableCell>
        <TableComponents.TableCell>
          {formattedData(charge, 'cash_value')}
        </TableComponents.TableCell>
      </TableRow>
    );
  });
};

export default ChargesTableRow;
